<ng-container *skAutorun><sk-json-editor class="h-100" [(value)]="json"></sk-json-editor></ng-container>